import React from 'react';
import { Link } from "react-router-dom"
const Eighthgrade_k8_subjects = () => {
  return (
    <div  className='fixed top-30 right-0 left-0 h-7 justify-center justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-blue-300 items-center z-50'>
    
    <Link to="/learning/eighthgrade_k8/eighthgrade_k8eng" className='text-white text-sm flex  rounded-md px-3 pb-2 pt-2'>English Language Arts</Link>
    <Link to="/learning/eighthgrade_k8/eighthgrade_k8math" className='text-white text-sm flex  rounded-md px-3 pb-2 pt-2'>Mathematics</Link>
    <Link to="/learning/eighthgrade_k8/eighthgrade_k8scie" className='text-white text-sm flex  rounded-md px-3 pb-2 pt-2'>Science</Link>
    <Link to="/learning/eighthgrade_k8/eighthgrade_k8soc" className='text-white text-sm flex  rounded-md px-3 pb-2 pt-2'>Social studies</Link>
      
    </div>
  );
}

export default Eighthgrade_k8_subjects;
